<div class="d-flex align-items-center">
  <div class="" style="width: 300px;">
    <ng-container>
      <ng-select
        class="form-control"
        [formControl]="period"
        [items]="periods"
        bindLabel="period"
        placeholder="{{ 'timefilter_dates_choose' | translate }}"
        (change)="onSelectionChange($event)"
      ></ng-select>
    </ng-container>
  </div>
  <span class="ms-5" translate>common_from</span>
  <wsb-atlas-datepicker [formControl]="dateFrom" [max]="dateTo.value ? dateTo.value : today" class="ms-3"></wsb-atlas-datepicker>
  <span class="ms-5" translate>common_to</span>
  <wsb-atlas-datepicker [min]="dateFrom.value" [max]="today" class="ms-3" [formControl]="dateTo"></wsb-atlas-datepicker>
  <wsb-atlas-button
    class="ms-5"
    [label]="'common_search'"
    [disabled]="!dateFrom.value || !dateTo.value"
    [variant]="'primary'"
    (click)="search()"
  >
  </wsb-atlas-button>
</div>

<div class="my-5">
  <div class="w-100" style="display: block;">
    <canvas
      baseChart
      width="400"
      height="200"
      *ngIf="lineChartPerDayOptions"
      [datasets]="lineChartPerDayData"
      [labels]="lineChartPerDayLabels"
      [options]="lineChartPerDayOptions"
      [type]="lineChartPerDayType"
    >
    </canvas>
  </div>
</div>

<div class="">
  <table class="table">
    <thead>
      <tr>
        <th translate>stats_pages_details_clic_title</th>
        <th translate>stats_pages_details_clic_number</th>
      </tr>
    </thead>

    <tbody *ngIf="pageClickByDay">
      <tr *ngFor="let link of pageClickByDay">
        <td class="left-column">{{ link.resource }}</td>
        <td class="right-column">{{ link.statistics.total }}</td>
      </tr>
    </tbody>
  </table>
</div>
